import { render, staticRenderFns } from "./FormAddOrEditItem.vue?vue&type=template&id=5a733efa&scoped=true"
import script from "./FormAddOrEditItem.vue?vue&type=script&lang=js"
export * from "./FormAddOrEditItem.vue?vue&type=script&lang=js"
import style0 from "./FormAddOrEditItem.vue?vue&type=style&index=0&id=5a733efa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a733efa",
  null
  
)

export default component.exports